import { useEffect, useState } from "react";
import moment from "moment";
import MyButton from "../Shared/Button";
import { useLocation, useNavigate } from "react-router-dom";
// import { getCall, postCall, putCall } from "../../../Api/axios";
import useForm from "../../hooks/useForm";
import {
  PRODUCT_SUBCATEGORY,
  FIELD_NOT_ALLOWED_BASED_ON_PROTOCOL_KEY,
  MAX_STRING_LENGTH,
  MAX_STRING_LENGTH_50,
  MAX_STRING_LENGTH_14,
  MAX_STRING_LENGTH_3,
  MAX_STRING_LENGTH_6,
  MAX_STRING_LENGTH_10,
  MAX_STRING_LENGTH_13,
  MAX_STRING_LENGTH_8,
  MAX_STRING_LENGTH_12,
} from "../../utils/constants";
import { isAmountValid, isNumberOnly } from "../../utils/validations";
import {
  allProductFieldDetails,
  categoryFields,
  productDetailsFields,
  variationCommonFields,
  UOMVariationFields,
} from "./product-fields";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import AddVariants from "./AddVariants";
import { allProperties } from "./categoryProperties";
import AddProductInfo from "./AddProduxtInfo";
import { getFormErrors } from "./utils";
import VitalForm from "./VitalForm";
import { v4 as uuidv4 } from "uuid";
import { countryNameToID } from "../../utils/countries";

interface AddGenericProductProps {
  state: any;
  barCodeForm: any;
  category: string;
  subCategory: string;
  categoryForm: any;
  selectedVariantNames: string[];
  variants: any[];
  attributes: any[];
  variationOn: string;
}

interface Field {
  id: string;
  title: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  options?: any[];
  file_type?: string | null;
}

interface FormValues {
  [key: string]: any;
}

interface FormErrors {
  [key: string]: string;
}

const AddGenericProduct: React.FC<AddGenericProductProps> = ({
  state,
  barCodeForm,
  category,
  subCategory,
  categoryForm,
  selectedVariantNames,
  variants,
  attributes,
  variationOn,
}) => {
  const navigate = useNavigate();
  const hasVariants = selectedVariantNames.length > 0;
  const [allFields, setAllFields] = useState<Field[]>(allProductFieldDetails);
  const [focusedField, setFocusedField] = useState<any>("");
  const [productInfoFields, setProductInfoFields] = useState<string[]>([]);

  const [variantFields, setVariantFields] = useState<Field[]>([]);
  const [variantInitialValues, setVariantInitialValues] = useState<FormValues>({});
  const [variantForms, setVariantForms] = useState<any[]>([]);
  const [variantFormsErrors, setVariantFormsErrors] = useState<FormErrors[]>([]);

  const [vitalForm, setVitalForm] = useState<FormValues>({});
  const [vitalFormErrors, setVitalFormErrors] = useState<FormErrors>({});
  const [vitalFields, setVitalFields] = useState<Field[]>([]);
  const [tabErrors, setTabErrors] = useState<boolean[]>([true, true, true]);
  const [formValidate, setFormValidate] = useState<boolean>(false);
  const [submitClicked, setSubmitClicked] = useState<boolean>(false);

  const [customizationGroups, setCustomizationGroups] = useState<any[]>([]);
  const [customizations, setCustomizations] = useState<any[]>([]);

  const [tabValue, setTabValue] = useState<string>("1");

  const initialValues: FormValues = {
    productCode: "",
    productName: "",
    MRP: "",
    purchasePrice: "",
    HSNCode: "",
    GST_Percentage: "",
    quantity: "",
    barcode: "",
    maxAllowedQty: "",
    UOM: "",
    length: "",
    breadth: "",
    height: "",
    weight: "",
    manufacturerName: "",
    manufacturedDate: "",
    nutritionalInfo: "",
    additiveInfo: "",
    instructions: "",
    longDescription: "",
    description: "",
    vegNonVeg: "",
    isReturnable: "false",
    isCancellable: "false",
    availableOnCod: "false",
    images: [],
    manufacturerOrPackerName: "",
    manufacturerOrPackerAddress: "",
    commonOrGenericNameOfCommodity: "",
    monthYearOfManufacturePackingImport: "",
    importerFSSAILicenseNo: "",
    brandOwnerFSSAILicenseNo: "",
    fulfillmentOption: "",
    countryOfOrigin: "",
    backImage: "",
  };

  const productInfoForm = useForm({
    ...initialValues,
  });

  const [backImagePath, setBackImagePath] = useState<string>("");

  const { formValues, setFormValues, errors, setErrors } = productInfoForm;

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const formatAttributesToFieldsDataFormat = (variants: any[], required: boolean = false): Field[] => {
    return variants.map((variant) => {
      return {
        id: variant.name.replace(/ /g,"_").toLowerCase(),
        title: variant.name,
        placeholder: variant.example,
        type: variant.type || "input",
        required: required || variant.required,
        options: variant.type === "select" ? variant.options : null,
        file_type: variant.type === "upload" ? "product_image" : null,
      };
    });
  };

  const formattedVariantDataForAddProduct = (): any[] => {
    let variant_forms_data = [...variantForms];

    return variant_forms_data.map((variantData) => {
      if (variationOn === "attributes") {
        let variant_attrs = selectedVariantNames.reduce((acc: any, variant_name: string) => {
          acc[variant_name] = variantData[variant_name];
          delete variantData[variant_name];
          return acc;
        }, {});

        variantData["varientAttributes"] = variant_attrs;
      }
      delete variantData["formKey"];
      delete variantData["uploaded_urls"];
      delete variantData["tempURL"];

      return variantData;
    });
  };

  const addProduct = async (): Promise<void> => {
    try {
        console.log(formValues,'asdas');
        
      let product_data = Object.assign({}, formValues, categoryForm.formValues);
      let vital_data = Object.assign({}, vitalForm);
      let variant_data = formattedVariantDataForAddProduct();
      let api_url =
        variationOn === "none"
          ? "/api/v1/products"
          : "/api/v1/productWithVariant";

      const subCatList =
        PRODUCT_SUBCATEGORY[categoryForm.formValues?.productCategory];
      const selectedSubCatObject = subCatList.find(
        (subitem:any) =>
          subitem.value === categoryForm.formValues?.productSubcategory1
      );
      if (selectedSubCatObject && selectedSubCatObject.protocolKey) {
        const hiddenFields =
          FIELD_NOT_ALLOWED_BASED_ON_PROTOCOL_KEY[
            selectedSubCatObject.protocolKey
          ];
        hiddenFields.forEach((field:any) => {
          delete product_data[field];
        });
      }

      if (variationOn !== "none") {
        variationCommonFields.forEach((field) => {
          delete product_data[field];
        });
      }


      // Format the duration in ISO 8601 form
      product_data.isCancellable =
        product_data.isCancellable === "true" ? true : false;
      product_data.isReturnable =
        product_data.isReturnable === "true" ? true : false;
      product_data.availableOnCod =
        product_data.availableOnCod === "true" ? true : false;

      delete product_data["uploaded_urls"];
      delete vital_data["tempURL"];

      let data :any = {
        commonDetails: product_data,
        commonAttributesValues: vital_data,
        customizationDetails: {
          customizationGroups,
          customizations,
        },
      };

      if (variationOn !== "none") {
        data["variantSpecificDetails"] = variant_data;
        data["variationOn"] = variationOn?.toUpperCase();
      }
     
    //   await cancellablePromise(postCall(api_url, data));
    //   cogoToast.success("Product added successfully!");
      navigate("/application/inventory");
    } catch (error: any) {
      console.log(error);
    //   cogoToast.error(error.response.data.error);
    }
  };

  const catalogueUOMToOndcUOM: Record<string, string> = {
    g: "gram",
    kg: "kilogram",
    l: "litre",
    ml: "millilitre",
    mtr: "meter",
    pack: "unit",
    pc: "unit",
    pull: "unit",
    roll: "unit",
    set: "unit",
    stick: "unit",
    wipe: "unit",
    page: "unit",
    sheet: "unit",
    tab: "unit",
    box: "unit",
    cup: "unit",
  };

//   const getProduct = (): void => {
//     getCall(`/api/v1/products/${state.productId}`)
//       .then((resp) => {
//         resp.commonDetails["uploaded_urls"] =
//           resp?.commonDetails.images?.map((i: any) => i?.url) || [];
//         resp.commonDetails["images"] =
//           resp?.commonDetails.images?.map((i: any) => i?.path) || [];

//         resp.commonDetails.isCancellable = resp.commonDetails.isCancellable
//           ? "true"
//           : "false";
//         resp.commonDetails.isReturnable = resp.commonDetails.isReturnable
//           ? "true"
//           : "false";
//         resp.commonDetails.isVegetarian = resp.commonDetails.isVegetarian
//           ? "true"
//           : "false";
//         resp.commonDetails.availableOnCod = resp.commonDetails.availableOnCod
//           ? "true"
//           : "false";
//         setBackImagePath(resp.commonDetails.backImage.path);
//         resp.commonDetails.backImage = resp.commonDetails.backImage.url;

//         const duration = moment.duration(resp.returnWindow);
//         const hours = duration.asHours();
//         resp.commonDetails.returnWindow = String(hours);
//         if (resp.commonAttributesValues["size_chart"]) {
//           resp.commonAttributesValues["size_chart"] =
//             resp.commonAttributesValues["size_chart"].url;
//         }
//         setFormValues({ ...resp.commonDetails });
//         setVitalForm({ ...resp.commonAttributesValues });

//         let category = resp.commonDetails["productCategory"];
//         let sub_category = resp.commonDetails["productSubcategory1"];
//         let customization_groups =
//           resp.customizationDetails?.customizationGroups?.map((group: any) => {
//             let optional = group.minQuantity === 0 ? true : false;
//             return { ...group, optional: optional };
//           });
//         // setCustomizationGroups(customization_groups);
//         // setCustomizations(resp.customizationDetails.customizations);

//         let attributes =
//           allProperties[category][sub_category] ||
//           allProperties[category]["default"];
//         setVitalFields(formatAttributesToFieldsDataFormat(attributes));
//       })
//       .catch((error) => {
//         cogoToast.error("Something went wrong!");
//         console.log(error);
//       });
//   };

  const updateProduct = async (): Promise<void> => {
    try {
      let product_data = Object.assign({}, formValues);
      let vital_data = Object.assign({}, vitalForm);
      const subCatList = PRODUCT_SUBCATEGORY[formValues?.productCategory];
      const selectedSubCatObject = subCatList.find(
        (subitem:any) => subitem.value === formValues?.productSubcategory1
      );
      if (selectedSubCatObject && selectedSubCatObject.protocolKey) {
        const hiddenFields =
          FIELD_NOT_ALLOWED_BASED_ON_PROTOCOL_KEY[
            selectedSubCatObject.protocolKey
          ];
        hiddenFields.forEach((field:any) => {
          delete product_data[field];
        });
      }

      let fields_to_remove = [
        "__v",
        "organization",
        "createdAt",
        "updatedAt",
        "published",
        "uploaded_urls",
        "createdBy",
        "_id",
        "variantGroup",
        "tempURL",
      ];

      fields_to_remove.forEach((field) => {
        delete product_data[field];
      });

      delete vital_data["tempURL"];
      if (backImagePath && product_data["backImage"].startsWith("https:")) {
        product_data["backImage"] = backImagePath;
      }

      let data = {
        commonDetails: product_data,
        commonAttributesValues: vital_data,
        customizationDetails: {
          customizationGroups,
          customizations,
        },
      };

    //   await putCall(`/api/v1/products/${state.productId}`, data);
    //   cogoToast.success("Product updated successfully!");
      navigate("/application/inventory");
    } catch (error) {
    //   cogoToast.error("Something went wrong!");
      console.log(error);
    }
  };

  const getProductFieldDetails = (category_id: string): Field => {
    return allFields.find((field) => field.id === category_id) as Field;
  };


  const getFulfillmentOptions = (fulfillments: any[]): void => {
    const availableOptions: {key: string, value: string}[] = [];
    fulfillments.forEach((fulfillment) => {
      if (fulfillment.id === "f1") {
        availableOptions.push({ key: "Delivery", value: "delivery" });
      }
      if (fulfillment.id === "f2") {
        availableOptions.push({ key: "Self Pickup", value: "selfPickup" });
      }
      if (fulfillment.id === "f3") {
        availableOptions.push({
          key: "Delivery And Self Pickup",
          value: "deliveryAndSelfPickup",
        });
      }
    });

    let updatedFields = [...allFields];
    const fulfillmentOptionIndex = allFields.findIndex(
      (field) => field.id === "fulfillmentOption"
    );
    if (fulfillmentOptionIndex !== -1) {
      updatedFields[fulfillmentOptionIndex].options = availableOptions;
      setAllFields(updatedFields);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (state?.productId) {
    //   getProduct();
    }
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    // getOrgDetails(user.organization);
  }, []);

  useEffect(() => {
    setProductInfoFields(getProductInfoFields());

    // Set vital form data
    let vital_fields = attributes.filter(
      (variant: any) => !selectedVariantNames.includes(variant.name)
    );
    vital_fields = formatAttributesToFieldsDataFormat(vital_fields);
    setVitalFields(vital_fields);
    let initial_values = vital_fields.reduce((acc: any, field: Field) => {
      acc[field.id] = "";
      return acc;
    }, {});
    setVitalForm(initial_values);

    // Set variant form data
    let default_variant_fields = variationCommonFields.map((field_id: string) =>
      getProductFieldDetails(field_id)
    );

    if (variationOn !== "none") {
      let variants_fields = getVariantsFields();
      let all_variant_fields = [...variants_fields, ...default_variant_fields];
      let variant_initial_values = all_variant_fields.reduce((acc: any, field: Field) => {
        acc[field.id] = field.id === "images" ? [] : "";
        return acc;
      }, {});
      setVariantFields(all_variant_fields);
      setVariantInitialValues(variant_initial_values);
      setVariantForms([{ ...variant_initial_values, formKey: uuidv4() }]);
    }
    // Set initial values for vital and variant tab
    let variant_tab_error = true;
    let vital_tab_error = true;

    if (variationOn === "none") {
      variant_tab_error = false;
    }

    if (Object.keys(vital_fields).length === 0) {
      vital_tab_error = false;
    }

    setTabErrors((prevState) => {
      prevState[1] = vital_tab_error;
      prevState[2] = variant_tab_error;
      return prevState;
    });
  }, [variationOn]);

  const getProductInfoFields = (): string[] => {
    let product_info_fields = [...productDetailsFields];
    let p_category = state?.productId ? state?.productCategory : category;
    let p_sub_category = state?.productId
      ? state?.productSubCategory
      : subCategory;
    let protocolKey = PRODUCT_SUBCATEGORY[p_category]?.filter(
      (sub_category: any) => sub_category.value === p_sub_category
    )[0].protocolKey;

    if (protocolKey && protocolKey !== "") {
      let fields_to_remove =
        FIELD_NOT_ALLOWED_BASED_ON_PROTOCOL_KEY[protocolKey];
      product_info_fields = product_info_fields?.filter(
        (field) => !fields_to_remove.includes(field)
      );
    }

    if (category !== "Grocery" && category !== "F&B") {
      product_info_fields = product_info_fields.filter(
        (field) => field !== "vegNonVeg"
      );
    }

    if (!variationOn || variationOn === "none") {
      return [
        ...product_info_fields,
        ...UOMVariationFields,
        ...variationCommonFields,
      ];
    } else if (variationOn === "attributes") {
      return [...product_info_fields, ...UOMVariationFields];
    } else {
      return product_info_fields;
    }
  };

  const getVariantsFields = (): Field[] => {
    if (!variationOn || variationOn === "none") {
      return [];
    } else if (variationOn === "attributes") {
      let selected_variants = variants.filter((variant: any) =>
        selectedVariantNames.includes(variant.name)
      );
      return formatAttributesToFieldsDataFormat(selected_variants, true);
    } else if (variationOn === "uom") {
      return UOMVariationFields.map((field_id: string) =>
        getProductFieldDetails(field_id)
      );
    }
    return [];
  };

  const validateProductInfoForm = (): boolean => {
    let formErrors: FormErrors = {};
    formErrors.productCode =
      formValues?.productCode?.trim() === ""
        ? "Product code is not allowed to be empty"
        : !isNumberOnly(formValues?.productCode)
        ? "Please enter only digit"
        : formValues?.productCode?.length > MAX_STRING_LENGTH_13
        ? `Cannot be more than ${MAX_STRING_LENGTH_13} characters`
        : "";
    formErrors.productName =
      formValues?.productName?.trim() === ""
        ? "Product name is not allowed to be empty"
        : formValues?.productName?.length > MAX_STRING_LENGTH
        ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
        : "";
    formErrors.countryOfOrigin =
      formValues?.countryOfOrigin?.trim() === ""
        ? "Country of origin is not allowed to be empty"
        : "";
    formErrors.GST_Percentage =
      formValues?.GST_Percentage === "" ? "GST percentage is required" : "";
    formErrors.maxAllowedQty = !formValues?.maxAllowedQty
      ? "Please enter a valid Max. Allowed Quantity"
      : formValues?.maxAllowedQty?.length > MAX_STRING_LENGTH_10
      ? `Cannot be more than ${MAX_STRING_LENGTH_10} characters`
      : parseInt(formValues?.maxAllowedQty) > parseInt(formValues?.quantity)
      ? "Cannot be more than quantity"
      : "";
    formErrors.UOM = formValues?.UOM === "" ? "UOM unit is required" : "";
    formErrors.fulfillmentOption =
      formValues?.fulfillmentOption === undefined ||
      formValues?.fulfillmentOption === ""
        ? "Fulfillment Option is required"
        : "";
    formErrors.length =
      formValues?.length?.trim() === ""
        ? "Length is required"
        : formValues?.length.length > MAX_STRING_LENGTH_6
        ? `Cannot be more than ${MAX_STRING_LENGTH_6} characters`
        : "";
    formErrors.breadth =
      formValues?.breadth?.trim() === ""
        ? "Breadth is required"
        : formValues?.breadth.length > MAX_STRING_LENGTH_6
        ? `Cannot be more than ${MAX_STRING_LENGTH_6} characters`
        : "";
    formErrors.height =
      formValues?.height?.trim() === ""
        ? "Height is required"
        : formValues?.height.length > MAX_STRING_LENGTH_6
        ? `Cannot be more than ${MAX_STRING_LENGTH_6} characters`
        : "";
    formErrors.weight =
      formValues?.weight?.trim() === ""
        ? "Weight is required"
        : formValues?.weight.length > MAX_STRING_LENGTH_3
        ? `Cannot be more than ${MAX_STRING_LENGTH_3} characters`
        : "";
    formErrors.manufacturerName =
      formValues?.manufacturerName?.trim() === ""
        ? "Manufacturer name is required"
        : formValues?.manufacturerName?.length > MAX_STRING_LENGTH_50
        ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
        : "";
    formErrors.manufacturedDate =
      formValues?.manufacturedDate?.trim() === ""
        ? "Manufactured date is required"
        : "";
    if (productInfoFields.includes("nutritionalInfo")) {
      formErrors.nutritionalInfo =
        formValues?.nutritionalInfo?.trim() === ""
          ? "Nutritional info is required"
          : formValues?.nutritionalInfo?.length > MAX_STRING_LENGTH
          ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
          : "";
    }
    if (productInfoFields.includes("additiveInfo")) {
      formErrors.additiveInfo =
        formValues?.additiveInfo?.trim() === ""
          ? "Additive info is required"
          : formValues?.additiveInfo?.length > MAX_STRING_LENGTH
          ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
          : "";
    }
    formErrors.instructions =
      formValues?.instructions?.trim() === ""
        ? "Instruction is required"
        : formValues?.instructions?.length > MAX_STRING_LENGTH
        ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
        : "";
    formErrors.longDescription =
      formValues?.longDescription?.trim() === ""
        ? "Long description is required"
        : formValues?.longDescription?.length > MAX_STRING_LENGTH
        ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
        : "";
    formErrors.description =
      formValues?.description?.trim() === ""
        ? "Short description is required"
        : formValues?.description?.length > MAX_STRING_LENGTH
        ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
        : "";
    if (productInfoFields.includes("manufacturerOrPackerName")) {
      formErrors.manufacturerOrPackerName =
        formValues?.manufacturerOrPackerName?.trim() === ""
          ? "Manufacturer or packer name is required"
          : formValues?.manufacturerOrPackerName?.length > MAX_STRING_LENGTH_50
          ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
          : "";
    }
    if (productInfoFields.includes("manufacturerOrPackerAddress")) {
      formErrors.manufacturerOrPackerAddress =
        formValues?.manufacturerOrPackerAddress?.trim() === ""
          ? "Manufacturer or packer address is required"
          : formValues?.manufacturerOrPackerAddress?.length >
            MAX_STRING_LENGTH_50
          ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
          : "";
    }
    if (productInfoFields.includes("commonOrGenericNameOfCommodity")) {
      formErrors.commonOrGenericNameOfCommodity =
        formValues?.commonOrGenericNameOfCommodity?.trim() === ""
          ? "Common or generic name of commodity is required"
          : formValues?.commonOrGenericNameOfCommodity?.length >
            MAX_STRING_LENGTH_50
          ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
          : "";
    }
    if (productInfoFields.includes("monthYearOfManufacturePackingImport")) {
      formErrors.monthYearOfManufacturePackingImport =
        formValues?.monthYearOfManufacturePackingImport?.trim() === ""
          ? "Month year of manufacture packing import is required"
          : formValues?.monthYearOfManufacturePackingImport?.length >
            MAX_STRING_LENGTH
          ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
          : "";
    }
    if (productInfoFields.includes("importerFSSAILicenseNo")) {
      formErrors.importerFSSAILicenseNo =
        formValues?.importerFSSAILicenseNo?.trim() === ""
          ? "Importer FSSAI license no is required"
          : !isNumberOnly(formValues?.importerFSSAILicenseNo)
          ? "Please enter only digit"
          : formValues?.importerFSSAILicenseNo?.length > MAX_STRING_LENGTH_14
          ? `Cannot be more than ${MAX_STRING_LENGTH_14} characters`
          : "";
    }
    if (productInfoFields.includes("brandOwnerFSSAILicenseNo")) {
      formErrors.brandOwnerFSSAILicenseNo =
        formValues?.brandOwnerFSSAILicenseNo?.trim() === ""
          ? "Brand owner FSSAI license no is required"
          : !isNumberOnly(formValues?.brandOwnerFSSAILicenseNo)
          ? "Please enter only digit"
          : formValues?.brandOwnerFSSAILicenseNo?.length > MAX_STRING_LENGTH_14
          ? `Cannot be more than ${MAX_STRING_LENGTH_14} characters`
          : "";
    }
    if (variationOn === "none") {
      formErrors.MRP = !formValues?.MRP
        ? "Please enter a valid number"
        : !isAmountValid(formValues?.MRP)
        ? "Please enter only digit"
        : "";
      formErrors.purchasePrice = !formValues?.purchasePrice
        ? "Please enter a valid number"
        : !isAmountValid(formValues?.purchasePrice)
        ? "Please enter only digit"
        : "";
      formErrors.quantity = !formValues?.quantity
        ? "Please enter a valid Quantity"
        : !isNumberOnly(formValues?.quantity)
        ? "Please enter only digit"
        : "";
      formErrors.barcode = !formValues?.barcode
        ? "Please enter a valid Barcode"
        : !isNumberOnly(formValues?.barcode)
        ? "Please enter only digit"
        : formValues?.barcode?.length > MAX_STRING_LENGTH_12
        ? `Cannot be more than ${MAX_STRING_LENGTH_12} characters`
        : "";
      formErrors.images =
        formValues?.productCategory !== "f_and_b" &&
        formValues?.images.length < 3
          ? "Minimum 3 images are required"
          : "";

      formErrors.backImage =
        formValues?.backImage?.trim() === ""
          ? "Please upload an image of the back of the product."
          : "";
    }

    if (formValues?.productCategory) {
      const subCatList = PRODUCT_SUBCATEGORY[formValues?.productCategory];
      const selectedSubCatObject = subCatList?.find(
        (subitem: any) => subitem.value === formValues?.productSubcategory1
      );
      if (selectedSubCatObject && selectedSubCatObject.protocolKey) {
        const hiddenFields =
          FIELD_NOT_ALLOWED_BASED_ON_PROTOCOL_KEY[
            selectedSubCatObject.protocolKey
          ];
        hiddenFields?.forEach((field: string) => {
          formErrors[field] = "";
        });
      }
    }

    setErrors({
      ...formErrors,
    });

    console.log("Product Info errors", formErrors);

    let valid_form = !Object.values(formErrors).some((val) => val !== "");

    return valid_form;
  };

  const validateVitalInfoForm = (): boolean => {
    if (Object.keys(vitalFields).length === 0) {
      return true;
    } else {
      let form_errors = getFormErrors(vitalFields, vitalForm);
      let is_valid_form = form_errors
        ? !Object.values(form_errors).some((val) => val !== "")
        : true;
      setVitalFormErrors(form_errors);
      return is_valid_form;
    }
  };

  const validateVariantsForms = (): boolean => {
    if (variationOn === "none") {
      return true;
    } else {
      let forms_errors = variantForms.map((variant_form) =>
        getFormErrors(variantFields, variant_form)
      );
      let has_forms_errors = forms_errors.map((form_errors) =>
        Object.values(form_errors).some((val) => val !== "")
      );
      let are_valid_forms = !has_forms_errors.some((val) => val === true);
      setVariantFormsErrors(forms_errors);
      return are_valid_forms;
    }
  };

  const validateCustomizationDetails = (): boolean => {
    const getCustomizationGroupName = (groupId: string): string => {
      const group = customizationGroups.find((group) => group.id === groupId);
      return group ? group.name : "";
    };

    const getCustomizationName = (customizationId: string): string => {
      const customization = customizations.find(
        (customization) => customization.id === customizationId
      );
      return customization ? customization.name : "";
    };

    const selectedCustomizations = customizations.filter(
      (customization) => customization.parent
    );

    if (customizationGroups.length > 0) {
      const groupIdsWithCustomizations = new Set(
        selectedCustomizations.map((customization) => customization.parent)
      );
      const groupIds: any = new Set(customizationGroups.map((group) => group.id));

      if (groupIdsWithCustomizations.size < groupIds.size) {
        const missingGroups = [...groupIds].filter(
          (groupId) => !groupIdsWithCustomizations.has(groupId)
        );
        const missingGroupNames = missingGroups.map((groupId) =>
          getCustomizationGroupName(groupId)
        );
        // cogoToast.error(
        //   `Please add at least one customization for groups: ${missingGroupNames.join(
        //     ", "
        //   )}.`
        // );
        return false;
      }
    }

    const invalidCustomizations = selectedCustomizations.filter(
      (customization) =>
        !customization.child &&
        (!customization.price ||
          (customization.price <= 0 && customization.default === "false"))
    );

    if (invalidCustomizations.length > 0) {
      const errorMessages = invalidCustomizations.map((customization) => {
        const groupName = getCustomizationGroupName(customization.parent);
        const customizationName = getCustomizationName(customization.id);
        return `${groupName} [${customizationName}]`;
      });

    //   cogoToast.error(
    //     `Customizations with the following details must have a price greater than 0: ${errorMessages.join(
    //       ", "
    //     )}.`
    //   );
      return false;
    }

    return true;
  };

  const validate = (): boolean => {
    let product_info_form_validity = validateProductInfoForm();
    let vital_info_form_validity = validateVitalInfoForm();
    let variants_forms_validity = validateVariantsForms();
    let customization_details_validity = true;

    setTabErrors((prev_state) => {
      prev_state[0] = !product_info_form_validity;
      prev_state[1] = !vital_info_form_validity;
      prev_state[2] = !variants_forms_validity;
      prev_state[3] = !customization_details_validity;
      return [...prev_state];
    });

    let result =
      variants_forms_validity &&
      product_info_form_validity &&
      vital_info_form_validity;

    return result;
  };

  const handleSubmit = (): void => {
    if (validate()) {
      state?.productId ? updateProduct() : addProduct();
    }
  };

  const renderVariationsFields = (): any => {
    return (
      <AddVariants
        variantFields={variantFields}
        variantInitialValues={variantInitialValues}
        variantForms={variantForms}
        setVariantForms={setVariantForms}
        variantFormsErrors={variantFormsErrors}
      />
    );
  };

  const renderProductInfoFields = (): any => {
    return (
      <AddProductInfo
        allFields={allFields}
        fields={productInfoFields}
        category={category}
        subCategory={subCategory}
        state={state}
        form={productInfoForm}
        setFocusedField={setFocusedField}
      />
    );
  };

  const renderProductVitalFields = (): any => {
    return (
      <VitalForm
        fields={vitalFields}
        formData={vitalForm}
        onFormUpdate={setVitalForm}
        vitalFormErrors={vitalFormErrors}
      />
    );
  };

  useEffect(() => {
    if (!formValidate) {
      let formErrors: FormErrors = {};
      let focusFieldValue = formValues[focusedField]?.toString().trim();
      if (
        focusFieldValue !== "" &&
        focusedField === "manufacturerOrPackerName"
      ) {
        formErrors.manufacturerOrPackerName =
          formValues?.manufacturerOrPackerName?.trim() === ""
            ? "Manufacturer or packer name is required"
            : formValues?.manufacturerOrPackerName.length > MAX_STRING_LENGTH_50
            ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
            : "";
      } else if (
        focusFieldValue !== "" &&
        focusedField === "manufacturerOrPackerAddress"
      ) {
        formErrors.manufacturerOrPackerAddress =
          formValues?.manufacturerOrPackerAddress?.trim() === ""
            ? "Manufacturer or packer address is required"
            : formValues?.manufacturerOrPackerAddress.length >
              MAX_STRING_LENGTH_50
            ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
            : "";
      } else if (
        focusFieldValue !== "" &&
        focusedField === "commonOrGenericNameOfCommodity"
      ) {
        formErrors.description =
          formValues?.description?.trim() === ""
            ? "Short description cannot be empty"
            : formValues?.commonOrGenericNameOfCommodity.length >
              MAX_STRING_LENGTH_50
            ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
            : "";
      } else if (focusFieldValue !== "" && focusedField === "description") {
        formErrors.description =
          formValues?.description?.trim() === ""
            ? "Short description is required"
            : formValues?.description?.length > MAX_STRING_LENGTH
            ? `Cannot be more than ${MAX_STRING_LENGTH} characters`
            : "";
      }
      setErrors((prevErrors) => ({
        ...prevErrors,
        ...formErrors,
      }));
    } else {
      validate();
    }
  }, [formValues, focusedField]);

  return (
    <form>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleTabChange}
              textColor={tabErrors.includes(true) ? "inherit" : "primary"}
              centered
            >
              <Tab
                sx={{
                  color:
                    tabErrors[0] && Object.keys(errors).length > 0
                      ? "red"
                      : "none",
                }}
                label="Product Info"
                value="1"
              />
              {Object.keys(vitalFields).length > 0 && (
                <Tab
                  sx={{
                    color:
                      tabErrors[1] && Object.keys(errors).length > 0
                        ? "red"
                        : "none",
                  }}
                  label="Vital Info"
                  value="2"
                />
              )}
              {variationOn !== "none" && (
                <Tab
                  sx={{
                    color:
                      tabErrors[2] && Object.keys(errors).length > 0
                        ? "red"
                        : "none",
                  }}
                  label="Variations"
                  value="3"
                />
              )}
            </TabList>
          </Box>
          <TabPanel value="1">
            <div className="mt-2">{renderProductInfoFields()}</div>
          </TabPanel>
          <TabPanel value="2">
            <div className="mt-2">{renderProductVitalFields()}</div>
          </TabPanel>
          <TabPanel value="3">{renderVariationsFields()}</TabPanel>
        </TabContext>
      </Box>

      <div className="flex flex-row justify-center py-2 sm:pt-5 md:!mt-10">
        <MyButton
          type="button"
          title={state?.productId ? "Update Product" : "ADD PRODUCT"}
          variant="contained"
          className="!ml-5"
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default AddGenericProduct;